module.exports = __webpack_public_path__ + "DejaVuSerif-Italic.08f58f7678b545de5960.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/DejaVu/DejaVuSerif-Italic.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/fonts/DejaVu/DejaVuSerif-Italic.ttf?v=1.1
// module chunks = styles